import { configureStore } from "@reduxjs/toolkit";
// import counterReducer from '../features/counter/counterSlice';
import counterReducer from "./counterSlice";
import apiSlice from "./apiSlice";
import brandVerificationReducer from "./features/brandVerificationSlice";
import causeVerificationReducer from "./features/causeVerificationSlice";
import influencerVerificationReducer from "./features/influencerVerificationSlice";
import representativeVerificationReducer from "./features/representativeVerificationSlice";
import campaignReducer from "./features/campaignSlice";

export const store = configureStore({
  reducer: {
    counter: counterReducer,
    api: apiSlice,
    brandVerification: brandVerificationReducer,
    causeVerification: causeVerificationReducer,
    influencerVerification: influencerVerificationReducer,
    representativeVerification: representativeVerificationReducer,
    campaign: campaignReducer,
  },
});

export default store;
